import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  socialMedia = [
    {
      icon: 'fa-brands fa-facebook'
    },
    {
      icon: 'fa-brands fa-x-twitter'
    },
    {
      icon: 'fa-brands fa-behance'
    },
    {
      icon: 'fa-brands fa-dribbble'
    },
    {
      icon: 'fa-brands fa-linkedin'
    }
  ]
}
